/**
 * i18n - Lightweight internationalization for UI constants only.
 * DO NOT translate dynamic content from DB (clients, leads, notes, etc.).
 */

import en from './en.json';
import ar from './ar.json';
import he from './he.json';

export type LanguageKey = 'en' | 'ar' | 'he';

export const languages: Record<LanguageKey, Record<string, any>> = {
  en,
  ar,
  he,
} as const;

export const languageLabels: Record<LanguageKey, string> = {
  en: 'English',
  ar: 'العربية',
  he: 'עברית',
};
